import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';

import '@app/scss/pages/registrationArticle.scss';

const RegistrationArticle: React.FC = () => {
	const location = useLocation();
	return <div className="container registration-article">
		<div className="registration-article__inner">
			<h1>Why I need to register?</h1>
			<ul>
				<li>
					1. We don't sell your profile information
				</li>
				<li>
					2. We don't connect your profile with social accounts
				</li>
				<li>
					3. We just grant clinic minimal information about you with your permission only, that you will provide to it by yourself anyway.
				</li>
			</ul>

			<h2>What you get?</h2>

			<ul>
				<li>
					1. Save your time and don’t fill out the same information every time for each clinic when you need appointment or inquiry.
				</li>
				<li>
					2. Get access to you appointments connected information at one place.
				</li>
				<li>
					3. Easily stay in touch with clinic via platform chat at any time.
				</li>
				<li>
					4. Pay bills online without unnecessary red tape.
				</li>
			</ul>
			<div className="text-center mt10">
				<NavLink
					state={location.state?.data ? { data: location.state?.data } : undefined}
					to={{ pathname: '/registration' }}
					className="btn btn-primary"
				>
					Registration
				</NavLink>
			</div>
		</div>
	</div>;
};

export default RegistrationArticle;
